import { useQuery } from "@tanstack/react-query";

import { useCurrentOrgId } from "@/providers/auth/hooks";
import { useDomainServices } from "@/providers/DomainServices";

import { triggersQueryKeys } from "./triggersQueryKeys";

/** One trigger by id, in the unified shape. */
export function useTriggerById(triggerId: string | undefined, orgId?: string) {
  const { triggerService } = useDomainServices();
  const resolvedOrgId = useCurrentOrgId(orgId);

  return useQuery({
    queryKey: triggersQueryKeys.byId(resolvedOrgId, triggerId ?? ""),
    queryFn: ({ signal }) => {
      if (triggerId === undefined) {
        return Promise.reject(new Error("Invalid trigger id"));
      }
      return triggerService.getTriggerById(triggerId, {
        abortSignal: signal,
      });
    },
    enabled: triggerId !== undefined,
    staleTime: 30_000,
  });
}

/** One trigger by name, in the unified shape. */
export function useTrigger(name: string | undefined, orgId?: string) {
  const { triggerService } = useDomainServices();
  const resolvedOrgId = useCurrentOrgId(orgId);

  return useQuery({
    queryKey: triggersQueryKeys.byName(resolvedOrgId, name ?? ""),
    queryFn: ({ signal }) => {
      if (name === undefined) {
        return Promise.reject(new Error("Invalid trigger name"));
      }
      return triggerService.getTriggerByName(name, resolvedOrgId, {
        abortSignal: signal,
      });
    },
    enabled: name !== undefined,
    staleTime: 30_000,
  });
}
